import {Action, getModule, Module} from "vuex-module-decorators";
import store from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import {MdbsCore} from "@/api/tsclient";
import AlertModule from "@/store/modules/alert";

const client = new MdbsCore.NtdPatientsClient();

@Module({namespaced: true, name: 'ntdPatients', store: store})
export default class NtdPatientsModule extends BaseModule {
    @Action({rawError: true})
    async getNtdPatientForStudyPatient(id: string) {
        this.startLoading()
        try {
            const response = await client.getNtdPatientForStudyPatient(id);
            return response;
        } catch (e) {
            console.log(e);
        } finally {
            this.stopLoading()
        }
        return null;
    }

    @Action({rawError: true})
    async createNtdPatientForStudyPatient(payload: { studyPatientId: string, ntdPatientId: string }) {
        this.startLoading()
        try {
            const response =  await client.createNtdPatientForStudyPatient(payload.studyPatientId, payload.ntdPatientId);
            return response;
        } catch (e) {
            const alertModule = getModule(AlertModule, store);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading()
        }
        return null;
    }
}
